export default __webpack_public_path__ + "static/starter-pack-5d204137c61feaa0a7d0fe356a16c596.png";